import { render, staticRenderFns } from "./OrganizationPicker.vue?vue&type=template&id=452f4220"
import script from "./OrganizationPicker.vue?vue&type=script&lang=ts"
export * from "./OrganizationPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports